import { defaultConfig } from 'app/config/environment';

export function getNameUrl(url) {
  if (url) {
    const replace = url.match(`http.+/`);
    return url.replace(replace, '');
  }

  return url;
}

export function openInNewTab(url) {
  const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
  if (newWindow) newWindow.opener = null;
}

export function openInNewTabRouter(PATH, guid, step) {
  const url = PATH.replace(':guid', guid).replace(':step', step).replace('?', '');

  openInNewTab(url);
}

export function getQueryString(string) {
  let queryString = string;
  let query = {};

  // Remove the question mark "?" from the beginning of the chain
  queryString = queryString.slice(1);

  // Separate key-value pairs using the "&" character
  let pares = queryString.split('&');

  // Separate each key and value using the "=" character
  for (const parItem of pares) {
    let par = parItem.split('=');
    let clave = par[0];
    let valor = par[1] ? decodeURIComponent(par[1].replace(/\+/g, ' ')) : '';

    // Assign keys and values to JavaScript object
    query[clave] = valor;
  }

  return query;
}

export function getDomainTenant({ tenant, user }) {
  const { BASE_URL_ } = defaultConfig;

  // TODO: Redireccionar al dominio de FrontOffice segun el pais, Ahora solo se haca para mx y EDELVIVES_DIGITAL_PLUS hay que buscar una solución generica.
  if (tenant?.tenant?.guid === 'EDELVIVES_DIGITAL_PLUS' && user?.country_guid === 'mx') {
    return BASE_URL_.includes('.mx') ? BASE_URL_ : `${BASE_URL_.slice(0, BASE_URL_.length - 1)}.mx/`;
  }
  // TODO: Redireccionar al dominio de FrontOffice segun el pais, Ahora solo se haca para mx y EDELVIVES_DIGITAL_PLUS hay que buscar una solución generica.
  if (tenant?.tenant?.guid === 'EDELVIVES_DIGITAL_PLUS' && BASE_URL_.includes('.mx')) {
    return BASE_URL_.replace('.mx', '');
  }

  return BASE_URL_;
}

export function getGUID(url) {
  if (url) {
    const regex = /\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})\/[^\/]+/;
    const match = url.match(regex);

    if (match) {
      return match[1];
    }
  }

  return '';
}

/**
 * Convierte una URL relativa de file-storage a una URL completa
 * @param {string} url - URL a convertir (puede ser relativa o completa)
 * @returns {string} - URL completa si es file-storage, o la URL original si ya es completa
 */
export function getFullFileStorageUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }

  // Si ya es una URL completa (empieza con http:// o https://), devolverla tal cual
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // Si la URL empieza con "/files-storage" o contiene "files-storage", construir la URL completa
  if (url.startsWith('/files-storage') || url.includes('files-storage')) {
    const { BASE_URL_ } = defaultConfig;
    return BASE_URL_ + (url.startsWith('/') ? url.substring(1) : url);
  }

  // Si no es file-storage, devolver la URL original
  return url;
}
